
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/recovery-password",
      function () {
        return require("private-next-pages/auth/recovery-password/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/recovery-password"])
      });
    }
  